import { brandConfig } from '../../config/brands';
import { DEFAULT_SURVEY_QUESTIONS, type SurveyQuestionKey } from '../../config/brands/types';
import type { UserProfileResponse } from '../../hooks/useUserProfile';

/**
 * ブランド別のアンケート設問構成 (brandConfig.surveyQuestions) の先頭から、
 * まだ回答していない設問を返す。表示すべきアンケートが無ければ null。
 *
 * 表示条件: プロファイル取得済み・スキップしていない・未完了 (completed === false)・
 * かつブランド設定の設問に未回答が残っている。
 *
 * AppLayout の属性収集モーダルと、HypeAppHomePage のナビゲーションガイド起動判定
 * (ガイドはアンケート完了後に出す) の両方で参照する。backend の SURVEY_CONFIGS と
 * 一致させること。
 */
export function getPendingSurveyQuestion(
  userProfile: UserProfileResponse | undefined,
): SurveyQuestionKey | null {
  if (!userProfile || userProfile.attribute_collection_dismissed || userProfile.attribute_collection_completed !== false) {
    return null;
  }
  const answered: Record<SurveyQuestionKey, boolean> = {
    user_type: !!userProfile.attribute_user_type_answered,
    gender: !!userProfile.attribute_gender_answered,
    occupation: !!userProfile.attribute_occupation_answered,
    usage_purpose: !!userProfile.attribute_usage_purpose_answered,
    discovery_channel: !!userProfile.attribute_discovery_channel_answered,
  };
  const questions = brandConfig.surveyQuestions ?? DEFAULT_SURVEY_QUESTIONS;
  return questions.find((q) => !answered[q]) ?? null;
}
